import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { validateNIF } from "../../helpers/utils.js";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'

const PedirAjuda = (props) => {

  const formSchema = Yup.object().shape({
    nif: Yup.string()
    .required('O número de identificação fiscal (NIF) é obrigatório.')
    .length(9, 'O número de identificação fiscal (NIF) tem de ter 9 caracteres.')
    .test('validateNif', 'Número de identificação fiscal (NIF) inválido', function(value) {
      return validateNIF(value);
    }),
    nome: Yup.string()
      .required('O nome é obrigatório.'),
    email: Yup.string()
      .required('O e-mail é obrigatório.')
      .email('O e-mail é inválido.'),
    assunto: Yup.string()
      .required('O assunto é obrigatório.'),
    comentario: Yup.string()
      .required('O comentário é obrigatório.'),
    termos: Yup.boolean()
      .oneOf([true], 'Tem de aceitar a política de tratamento de dados.'),
  })
  const formOptions = { resolver: yupResolver(formSchema), mode:"onChange" }

  const { register, handleSubmit, reset, formState: { errors, isValid, isSubmitSuccessful } } = useForm(formOptions);

  const isButtonEnabled = isValid
  const handleInputChange = (event) =>{
    const nifNums = event.target.value.replace(/[^0-9]/g, '');
    event.target.value = nifNums;
  }

  const [message, setMessage] = useState('');

  useEffect(() => {
    if (isSubmitSuccessful === true)
    {
        setMessage("Pedido de ajuda enviado com sucesso.");

        setTimeout(function (){
          setMessage('')
        }, 5000);

        window.scrollTo(0, 0);
        reset()
    }
  }, [isSubmitSuccessful]);

  return (
  <div className="mt-5">
    {message.length !== 0 && (
        <div className="alert alert-success alert-layer border-0 d-flex align-items-center mb-5" role="alert">
          <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-2">
            <g stroke="none" strokeWidth="1" fill="#FFFFFF" fillRule="evenodd">
              <path d="M7.48581818,10.5709091 C7.344,10.7127273 7.15781818,10.784 6.97163636,10.784 C6.78545455,10.784 6.59927273,10.7127273 6.45745455,10.5709091 L4.40072727,8.51418182 L5.42909091,7.48581818 L6.97163636,9.02836364 L10.5709091,5.42909091 L11.5992727,6.45745455 L7.48581818,10.5709091 Z M8,0 C3.58909091,0 0,3.58836364 0,8 C0,12.4109091 3.58909091,16 8,16 C12.4109091,16 16,12.4109091 16,8 C16,3.58836364 12.4109091,0 8,0 L8,0 Z" />
            </g>
          </svg>
          <div>
          {message}
          </div>
        </div>
        )}
      <form onSubmit={handleSubmit(props.onSubmitHandler)}>
        <div className="row">
          <div className="form-group col-12">
            <label>Nome</label>
            <input {...register("nome")} className={`form-control ${errors.nome ? 'is-invalid' : ''}`} />
            <div className="invalid-feedback">{errors.nome?.message}</div>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-6 mt-2">
            <label>Número de identificação fiscal (NIF)</label>
            <input type="text" {...register("nif")} className={`form-control ${(errors.nif) ? 'is-invalid' : ''}`} onInput={handleInputChange} />
            <div className="invalid-feedback">{errors.nif?.message}</div>
          </div>
          <div className="form-group col-6 mt-2">
            <label>E-mail</label>
            <input {...register("email")} className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
            <div className="invalid-feedback">{errors.email?.message}</div>
          </div>
        </div>
        <div className="form-group mt-4">
          <label>Assunto</label>
          <select {...register("assunto")} defaultValue="" className={`form-control ${errors.assunto ? 'is-invalid' : ''}`}>
            <option value="" disabled>Selecione uma opção</option>
            <option value="Alteração de dados pessoais">Alteração de dados pessoais</option>
            <option value="Acesso a benefícios">Acesso a benefícios</option>
            <option value="Esclarecimento da área privada">Esclarecimento da área privada</option>
            <option value="Outros assuntos">Outros assuntos</option>
          </select>
          <div className="invalid-feedback">{errors.assunto?.message}</div>
        </div>
        <div className="form-group mt-4">
          <label>Comentário</label>
          <textarea {...register("comentario")} className={`form-control ${errors.comentario ? 'is-invalid' : ''}`} spellCheck={false} maxLength={500}/>
          <div className="invalid-feedback">{errors.comentario?.message}</div>
        </div>
        <div className="form-check mt-5">
          <input type="checkbox" {...register("termos")} className={`form-check-input ${errors.termos ? 'is-invalid' : ''}`} />
          <label className="form-check-label">Aceito a política de <a href="https://www.cgd.pt/Site/CXA/CGD-Pensoes/Pages/Politica-de-Privacidade.aspx" target="_blank" rel="noopener noreferrer">tratamento de dados.</a></label>
          <div className="invalid-feedback">{errors.termos?.message}</div>
        </div>
        <div className="mt-5">
          <button type="submit" className="btn btn-primary" disabled={!isButtonEnabled}>
            Enviar mensagem
          </button>
        </div>
      </form>
  </div>
  );
};

export default PedirAjuda;
